// extracted by mini-css-extract-plugin
export var divider = "_ws-0";